import { apiClient } from './client';
import type { AuthTokenResponse } from '@/types';

export const authApi = {
    exchangeToken(token: string, clientId: string) {
        return apiClient.post<AuthTokenResponse>('auth/token', { token, client_id: clientId });
    },

    logout() {
        return apiClient.post<void>('auth/logout');
    },

    refreshToken(token: string, refreshToken: string, clientId: string) {
        return apiClient.post<AuthTokenResponse>('auth/token/refresh', {
            token,
            refresh_token: refreshToken,
            client_id: clientId,
        });
    },
};
